import { render, staticRenderFns } from "./LdapAttributesNameValuesList.vue?vue&type=template&id=64a26c72&scoped=true"
import script from "./LdapAttributesNameValuesList.vue?vue&type=script&lang=js"
export * from "./LdapAttributesNameValuesList.vue?vue&type=script&lang=js"
import style0 from "./LdapAttributesNameValuesList.vue?vue&type=style&index=0&id=64a26c72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a26c72",
  null
  
)

export default component.exports